export default "__VITE_ASSET__DrosA7t9__"